import { http, HttpResponse } from 'msw';

export default {
    hintStatus: http.post('*/hint-status/', () =>
        HttpResponse.json({ uuid: 'hint-1', user: 1, feature: 'TRANSACTIONS_WELCOME_BANNER', is_completed: true })
    ),
    hintStatusComplete: http.post('*/hint-status/complete/', () => HttpResponse.json({})),
};
